<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <v-btn small color="primary" to="/customers">Back to Customers</v-btn>
        <v-card>
          <v-container grid-list-xl fluid>
            <h1 class="display-1">Add Customer</h1>
            <v-text-field label="First Name" v-model="firstName"></v-text-field>
            <v-text-field label="Last Name" v-model="lastName"></v-text-field>
            <v-text-field label="Email" v-model="email"></v-text-field>
            <v-text-field label="Phone" v-model="phone"></v-text-field>

            <h2 class="headline">Address</h2>
            <v-text-field label="Address" v-model="address.address"></v-text-field>
            <v-text-field label="City" v-model="address.city"></v-text-field>
            <v-text-field label="State" v-model="address.state"></v-text-field>
            <v-text-field label="Postcode" v-model="address.postcode"></v-text-field>

            <v-btn color="primary" large @click="addCustomer">Add</v-btn>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CustomerService from '@/services/CustomerService'
import AddressService from '@/services/AddressService'
export default {
  name: 'NewCustomer',
  data () {
    return {
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      address: {
        address: null,
        city: null,
        state: null,
        postcode: null
      }
    }
  },
  methods: {
    async addCustomer () {
      const addressResponse = await AddressService.createAddress(this.address)

      const customerResponse = await CustomerService.addCustomer({
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone,
        address: addressResponse.data.address._id
      })

      if (customerResponse.data.success) {
        this.$router.push({ name: 'Customers' })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/customers/NewCustomer.vue